import {URLSearchParams} from '@angular/http';
import {isNullOrUndefined} from 'util';

class URLSearchParamsBuilder {

    private readonly search: URLSearchParams;

    constructor() {
        this.search = new URLSearchParams();
    }

    public append(name: string, value: any): URLSearchParamsBuilder {
        if (!isNullOrUndefined(name) && !isNullOrUndefined(value)) {
            this.search.append(name, String(value));
        }

        return this;
    }

    public toSearch(): URLSearchParams {
        return this.search;
    }
}

export class HttpUtils {

    public static searchParams(): URLSearchParamsBuilder {
        return new URLSearchParamsBuilder();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/http.utils.ts